const MenuLine = ({ className = '', ...props }) => {
    return (
        <svg
            width="19"
            height="18"
            viewBox="0 0 19 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                d="M3.91992 7.5C3.09492 7.5 2.41992 8.175 2.41992 9C2.41992 9.825 3.09492 10.5 3.91992 10.5C4.74492 10.5 5.41992 9.825 5.41992 9C5.41992 8.175 4.74492 7.5 3.91992 7.5ZM14.4199 7.5C13.5949 7.5 12.9199 8.175 12.9199 9C12.9199 9.825 13.5949 10.5 14.4199 10.5C15.2449 10.5 15.9199 9.825 15.9199 9C15.9199 8.175 15.2449 7.5 14.4199 7.5ZM9.16992 7.5C8.34492 7.5 7.66992 8.175 7.66992 9C7.66992 9.825 8.34492 10.5 9.16992 10.5C9.99492 10.5 10.6699 9.825 10.6699 9C10.6699 8.175 9.99492 7.5 9.16992 7.5Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default MenuLine;
